import { createStore } from 'satcheljs';
import '../mutators/discardInvitationOption';
import '../mutators/selectForwardMeetingNotificationOption';
import '../mutators/selectOldMeetingMessageOption';
/*
    Creates store which reflects the current state of settings under invitation option
*/
export default createStore('invitationOption', {
    removeForwardedMeetingNotifications: null,
    removeOldMeetingMessages: null,
});
//# sourceMappingURL=store.js.map